import { createContext, useContext } from 'react';

// Context 객체 생성
const JsonViewerContext = createContext(null);

/**
 * JsonViewerContext를 쉽게 사용하기 위한 커스텀 훅.
 * Provider 외부에서 사용하는 실수를 방지해줍니다.
 */
export const useJsonViewerContext = () => {
    const context = useContext(JsonViewerContext);
    if (!context) {
        throw new Error('useJsonViewerContext must be used within a JsonViewer');
    }
    return context;
};

export default JsonViewerContext;